import React from 'react'
import { Box, Button, IconButton, Paper, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { grey } from '@mui/material/colors'
import { useGlobalState } from 'state'
import { ObservatoryRow } from 'common/types'
import { StageChart } from 'components/containers/ObservatoryContainer/StageChart'



export const StageChartContainer = () => {
  const state = useGlobalState()
  const observatories = React.useMemo(() => state.observatory.stageForecastData, [state.observatory.stageForecastData])

  const showTarget = (target: ObservatoryRow) => {
    state.observatory.setSelected(target)
    state.app.setObservatoryContainer(true)
  }

  return (
    <Box sx={{borderLeft: '1px solid #9e9e9e'}}>
      <Paper sx={{width: 610, height: '100dvh', backgroundColor: '#fafafa'}} elevation={0} square>
        <Stack direction="row" justifyContent="end" sx={{height: 35}}>
          <IconButton size='small' onClick={() => state.app.setMonitorContainer('none')}>
            <CloseIcon sx={{color: grey[500]}} fontSize='small' />
          </IconButton>
        </Stack>
        <Stack sx={{height: 'calc(100dvh - 45px)',overflowY: 'auto', scrollbarWidth: '10px'}} direction="row" flexWrap={'wrap'} alignItems={'flex-start'} justifyContent={'flex-start'}>
          { observatories.map((row, i)=>
            <Paper key={i} sx={{width: 280, height: 220, ml: '10px', mb: '14px'}} variant='outlined'>
              <Stack direction={'row'} px={'3px'} pt={'3px'}>
                <Typography variant='body2' sx={{ml: 1, mt: 1}}>{row.stage.name}</Typography>
                <Button variant='text' size='small' sx={{ml: 'auto', color: 'grey'}} onClick={() => showTarget(row.stage)}>詳細をみる</Button>
              </Stack>
              { row.timeSeries.length > 0 && <StageChart stage={row.stage} height={200} timeSeries={row.timeSeries} /> }
              { row.timeSeries.length === 0 && <Box width={'auto'} height={180} mx={'auto'}>
                <Typography color={grey[700]} variant='body2' textAlign={'center'} mt={5}>データがありません</Typography></Box> }
            </Paper>
          )}
        </Stack>
      </Paper>
    </Box>
  )
}
